<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="关键词" class="title">
        <el-input v-model="keywordData.keyword"></el-input>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywordData: {
        keyword:""
      },
    };
  },
  mounted() {
  },
  methods: {

    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-range-editor.el-input__inner {
  width: 490px;
}
.pc-search {
  @include table-search;
  .competition {
    width: 400px;
  }
  .title {
    width: 600px;
  }
  .updateTime {
    width: 600px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 200px;
  }
  .keyword {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/content/components/thesaurusManagementSearch.vue